import React, { useState, useEffect } from "react";
import { Container, TextField, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { getSchema } from "./utils";

import { adminLoginService } from "../../auth/service";
import { adminInfoStorageService } from "../../../shared/services";

const LoginHR = () => {
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    resolver: yupResolver(getSchema()),
  });

  const handleLogin = async (admin) => {
       const { data, error } = await adminLoginService(admin);

    if (data) {
      adminInfoStorageService(data);
      navigate("/hr-portal/job-listing");
      return;
    }
    if (error) {
      console.log(errors);
      setError(error);
      setTimeout(() => {
        setError("");
      }, 2000);
    }
  };
  useEffect(() => {
     localStorage.removeItem("obenev-token");
  }, []);

  return (
    <Container className="login-container">
      <Typography className="login-header">ObenEv for HR</Typography>
      <form onSubmit={handleSubmit(handleLogin)}>
        <TextField
          {...register("email")}
          label="Email"
          fullWidth
          variant="outlined"
          error={errors.email}
          helperText={errors.email?.message}
        />
        <TextField
          {...register("password")}
          label="Password"
          type="password"
          fullWidth
          variant="outlined"
          error={errors.password}
          helperText={errors.password?.message}
        />
        <Button fullWidth variant="contained" type="submit">
          Login
        </Button>
      </form>
    </Container>
  );
};
export default LoginHR;
